import { render } from "./BeforeFooter.vue?vue&type=template&id=07bc93c0&scoped=true"
import script from "./BeforeFooter.vue?vue&type=script&lang=js"
export * from "./BeforeFooter.vue?vue&type=script&lang=js"

import "./BeforeFooter.vue?vue&type=style&index=0&id=07bc93c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07bc93c0"]])

export default __exports__